(function () {
    document.addEventListener("DOMContentLoaded", function (event) {
        var shareModules = document.querySelectorAll(".share-module");
        Array.prototype.forEach.call(shareModules, function (el, i) {
            var currentShareModules = shareModules[i];
            showShareIcons(currentShareModules);
        });

    });

    function showShareIcons(currentElement) {
        var currentElementList = currentElement.querySelector('.share-module--links');
        var pageTitle = document.title;

        currentElement.classList.remove('is-d-none');

        if (navigator.share) {
            currentElementList.innerHTML = '<li><button class="native-share-cta" aria-label="share"><i class="rethink-icon rethink-icon-share"></i></button></li>';
            var nativeShareCta = currentElementList.querySelector('.native-share-cta');

            nativeShareCta.addEventListener("click", function () {
                navigator.share({
                    title: pageTitle,
                    url: window.location.href
                });
            });

        } else {
            var sharers = [
                {
                    name: 'facebook',
                    url: window.location.href,
                    title: pageTitle,
                    icon: 'facebook',
                    to: '',
                    subject: ''
                },
                {
                    name: 'twitter',
                    url: window.location.href,
                    title: pageTitle,
                    icon: 'twitter',
                    to: '',
                    subject: ''
                },
                {
                    name: 'linkedin',
                    url: window.location.href,
                    title: pageTitle,
                    icon: 'linkedin-square',
                    to: '',
                    subject: ''
                },
                {
                    name: 'whatsapp',
                    url: window.location.href,
                    title: pageTitle,
                    icon: 'whatsapp',
                    to: '',
                    subject: ''
                },
                {
                    name: 'email',
                    url: window.location.href,
                    title: pageTitle,
                    icon: 'email',
                    to: ' ',
                    subject: ''
                }
            ];

            var currentElementListContent = [];

            Array.prototype.forEach.call(sharers, function (el, i) {
                var listItemContent = `<li class="item-${sharers[i].name}">
                                        <button
                                            data-sharer="${sharers[i].name}"
                                            data-title="${sharers[i].title}"
                                            data-url="${sharers[i].url}"
                                            data-subject="${sharers[i].subject}"
                                            data-to="${sharers[i].to}">
                                            <i class="rethink-icon rethink-icon-${sharers[i].icon}" aria-label="share on ${sharers[i].name}"></i>
                                        </button>
                                       </li>`;
                currentElementListContent.push(listItemContent);
            });
            currentElementList.innerHTML = currentElementListContent.join(' ');
            window.Sharer.init();
        }
    }
})();
